import React, { FC } from "react";

interface Props {}

export const RequiredBadge: FC<Props> = ({}) => (
  <span className="inline-flex items-center mx-0.5 px-1 py-0.5 rounded font-normal text-xs bg-red-50 text-red-400">
    required
  </span>
);
